import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';
import { USER_PERMISSIONS } from 'src/constants/user';
import { hasPermissions } from 'src/utils/helpers';
import './style.scss';

interface INotificationsCountProps {
  count: string;
  color?: 'red' | 'blue';
}

@observer
export default class NotificationsCount extends React.Component<INotificationsCountProps> {
  static defaultProps = {
    count: '0',
  };

  render() {
    if (this.props.count === '0' || !hasPermissions(USER_PERMISSIONS.ORDERS_MANAGMENT)) return null;
    const { color = 'blue' } = this.props;

    return (
      <div
        className={classNames('notifications-count', {
          'bg-red': color === 'red',
          'bg-mainblue': color === 'blue',
        })}
      >
        <span className="text-size-14 family-semibold color-white">{this.props.count}</span>
      </div>
    );
  }
}
